import React, { createContext, useContext, useState } from "react";
import { OrderLogRepository } from "../../repository/AdminDashboard/Order_repository";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

const StateContext = createContext();
const initialState = {
  orderTable: [],
  orderedit: {
    status: "",
    code: "",
  },
};
const OrderLogContext = ({ children }) => {
  const [orderTable, setorderTable] = useState(initialState.orderTable);
  const [name, setname] = useState("");
  const [status, setstatus] = useState("");
  const [orderNumber, setorderNumber] = useState("");
  const [orderdate, setorderdate] = useState("");
  const [reciver, setreciver] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [postalcode, setpostalcode] = useState("");
  const [city, setcity] = useState("");
  const [address, setaddress] = useState("");
  const [totalAmount, settotalAmount] = useState("");
  const [paymentMethod, setpaymentMethod] = useState("");
  const [transactionNumber, settransactionNumber] = useState("");
  const [Amount, setAmount] = useState("");
  const [deliverycost, setdeliverycost] = useState("");
  const [deliverycode, setdeliverycode] = useState("");
  const [id, setid] = useState("");
  const [loaded, setloaded] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [statuschange, setstatuschange] = useState(
    initialState.orderedit.status
  );
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [deleted, setdeleted] = useState(false);
  const [codechange, setcodechange] = useState(initialState.orderedit.code);
  const getorderDetail = async (editorder) => {
    setloaded(true);
    const orderDetail_data = await OrderLogRepository.getorderLog(editorder);
    setname(orderDetail_data.name);
    setstatus(orderDetail_data.status);
    setorderNumber(orderDetail_data.orderNumber);
    setorderdate(orderDetail_data.orderdate);
    setreciver(orderDetail_data.reciver);
    setphoneNumber(orderDetail_data.phoneNumber);
    setpostalcode(orderDetail_data.postalcode);
    setcity(orderDetail_data.city);
    setaddress(orderDetail_data.address);
    settotalAmount(orderDetail_data.totalAmount);
    setpaymentMethod(orderDetail_data.paymentMethod);
    settransactionNumber(orderDetail_data.transactionNumber);
    setAmount(orderDetail_data.Amount);
    setdeliverycost(orderDetail_data.deliverycost);
    setdeliverycode(orderDetail_data.deliverycode);
    setorderTable(orderDetail_data.orderTable);
    setid(orderDetail_data.id);
    setloaded(false);
    // console.log(orderDetail_data)
  };
  const navigate = useNavigate();
  const getdeleteData = async (id) => {
    const orderdelete_data = await OrderLogRepository.deleteorder(id);
    if (orderdelete_data.code == 1) {
      navigate("/order");
      setdeleted(true);
      setTimeout(() => {
        toast.success(orderdelete_data.massage, {
          className: "text-12 text-dark-blue-200",
        });
      }, 1000);
    } else if (orderdelete_data.code == 0) {
      setdeleted(false);

      toast.error(orderdelete_data.massage, {
        className: "text-12 text-dark-blue-200",
      });
    }
  };
  const editOrder = () => {
    // console.log("hujo");
    setshowModal(true);
  };
  const closeModal = () => {
    setshowModal(false);
    setcodechange("");
    setstatuschange("");
  };
  // selectbox
  const changestatus = (event) => {
    if (event.length > 0) {
      setstatuschange(event[0].value);
    }
  };
  // handlechange input
  const onchangeInput = (event) => {
    setcodechange(event.target.value);
  };
  const doneEdit = async () => {
    setshowModal(false);
    // console.log(initialState.orderedit);
    await getorderDetail(initialState.orderedit);
    setcodechange("");
    setstatuschange("");
  };
  initialState.orderedit.code = codechange;
  initialState.orderedit.status = statuschange;

  // delete order
  const onDelete = () => {
    setshowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setshowDeleteModal(false);
  };

  const RemoveItem = async () => {
    setshowDeleteModal(false);
    await getdeleteData(id);
  };
  return (
    <StateContext.Provider
      value={{
        name,
        status,
        orderNumber,
        orderdate,
        getorderDetail,
        reciver,
        phoneNumber,
        postalcode,
        city,
        address,
        totalAmount,
        paymentMethod,
        transactionNumber,
        Amount,
        deliverycost,
        deliverycode,
        orderTable,
        loaded,
        editOrder,
        showModal,
        closeModal,
        changestatus,
        onchangeInput,
        doneEdit,
        showDeleteModal,
        closeDeleteModal,
        RemoveItem,
        deleted,
        onDelete,
      }}>
      {children}
    </StateContext.Provider>
  );
};
function OrderLogUseContext() {
  return React.useContext(StateContext);
}
export default OrderLogContext;
export { OrderLogUseContext };
